<template>
    <!-- 结单 -->
    <div class="public_container add_approval_wrap">
        <div class="returnNavBar">
            <ReturnNavBar title="返回" :isTitleNormal="true" :isAllFunctions="true"></ReturnNavBar>
        </div>
        <div class="work_order_add_container mobile_container custom_mobile_form" v-loading="loading">
            <van-form
                label-width="9.5em"
                input-align="right"
                scroll-to-error
                :show-error-message="false"
                :rules="workOrderFinishFormRules"
                ref="workOrderFinishForm"
                class=""
            >
                <van-field
                    :required="true"
                    v-model="workOrderFinishForm.start_date_text"
                    name="start_date"
                    label="开始时间"
                    placeholder="请选择"
                    :rules="workOrderFinishFormRules.start_date"
                    error-message-align="right"
                    is-link
                    readonly
                    @click="handleClickDateFieldlink('start_date')"
                >
                </van-field>
                <van-field
                    :required="true"
                    v-model="workOrderFinishForm.end_date_text"
                    name="end_date"
                    label="结束时间"
                    placeholder="请选择"
                    :rules="workOrderFinishFormRules.end_date"
                    error-message-align="right"
                    is-link
                    readonly
                    @click="handleClickDateFieldlink('end_date')"
                >
                </van-field>
                <van-field name="duration" label="时长（天）" placeholder="请输入" error-message-align="right" readonly>
                    <template #input>
                        <span>时长{{ workOrderFinishForm.duration }}天（{{ workOrderFinishForm.days }}人日）</span>
                    </template>
                </van-field>
                <van-field
                    v-model="workOrderFinishForm.processing_uid"
                    name="processing_uid"
                    label="实施人"
                    placeholder="请选择"
                    error-message-align="right"
                    is-link
                    readonly
                >
                    <template #input>
                        <span>{{ processingUidData.map((item) => item.name).join() }}</span>
                    </template>
                </van-field>
                <van-field
                    :required="is_finish_upload"
                    name="files"
                    label="实施报告/证明"
                    placeholder="请选择"
                    readonly
                    class="vertical_input_wrap"
                >
                    <template #input>
                        <div class="form_upload_wrap">
                            <p class="tip_info">支持Word、Excel、PDF等常见类型</p>
                            <ul class="upload_file_list">
                                <li v-for="(file, file_idx) in workOrderFinishForm.files" class="upload_file_item">
                                    <div class="file_left_wrap">
                                        <img
                                            alt=""
                                            class="file_img"
                                            src="https://download.hecoos.com/enlightv/2023-37/chyZ4zyQiQkR5byRwSCT.png"
                                        />
                                        <div class="file_info_wrap">
                                            <p class="file_name" v-text="file.file_name"></p>
                                            <p class="file_size" v-text="file.file_size"></p>
                                        </div>
                                    </div>
                                    <div class="file_right_wrap">
                                        <el-tooltip content="预览" effect="dark" placement="top">
                                            <span class="handle_icon_wrap" @click="handleClickPreview(file)">
                                                <i class="iconfont icon-yanjing"></i>
                                            </span>
                                        </el-tooltip>
                                        <span class="line"></span>
                                        <el-tooltip content="删除" effect="dark" placement="top">
                                            <span
                                                class="handle_icon_wrap handle_icon_danger_wrap"
                                                @click="workOrderFinishForm.files.splice(file_idx, 1)"
                                            >
                                                <i class="iconfont icon-shanchu1"></i>
                                            </span>
                                        </el-tooltip>
                                    </div>
                                </li>
                                <li class="upload_file_btn_wrap" :class="{ mt_34: !workOrderFinishForm.files.length }">
                                    <i class="iconfont icon-shangchuan"></i>
                                    <span>上传附件</span>
                                    <input
                                        class="upload_input"
                                        multiple
                                        type="file"
                                        @change="handleUploadFileChange($event, 'files', workOrderFinishForm)"
                                    />
                                </li>
                            </ul>
                        </div>
                    </template>
                </van-field>
                <van-field
                    :required="is_finish_content"
                    v-model="workOrderFinishForm.note"
                    name="note"
                    label="结单描述"
                    placeholder="请输入"
                    :rules="finishContentRules"
                    error-message-align="right"
                    type="textarea"
                    :rows="5"
                    maxlength="500"
                    input-align="left"
                    class="vertical_input_wrap"
                >
                </van-field>
            </van-form>
            <div class="add_approval_select_process">
                <approveProcessSelect
                    ref="approveProcessSelectRef"
                    :approval_node_list="approval_node_list"
                ></approveProcessSelect>
            </div>
        </div>
        <div class="add_footer_wrap mobile_add_footer_wrap">
            <van-button round block type="info" :disabled="btnDisabled" @click="handleClickConfirm">确定</van-button>
        </div>
        <!--_年_月_日 日期选择-->
        <van-calendar
            v-model="showDateCalendar"
            color="#2990FF"
            :min-date="dateCalendarMin"
            :max-date="dateCalendarMax"
            @confirm="handleDateCalenderConfirm"
        />

        <van-overlay
            :custom-style="{ background: 'rgba(0, 0, 0, 0.3)' }"
            z-index="1000"
            v-if="handleRadioPicker"
            :show="handleRadioPicker"
            @click="handleRadioPicker = false"
        >
            <div class="custome_radio_option_wrap">
                <ul class="radio_option_list">
                    <li
                        class="radio_option_item"
                        v-for="item in radioOptions"
                        :key="item.value"
                        @click="handleClickOption(item)"
                    >
                        {{ item.label }}
                    </li>
                    <div class="cancel_btn" @click="handleClickRadioCancel">取消</div>
                </ul>
            </div>
        </van-overlay>
        <el-image ref="preview_img" :preview-src-list="previewImgList" :src="previewImgSrc" style="display: none">
        </el-image>
    </div>
</template>
<script>
import { workOrderSetDetail, workOrderFinish, getApprovalNodes, workOrderFinishDetail } from "@/api";
import { formatFileSize, getNowDate, formatDate } from "@/utils";
import { uploadImg } from "@/utils/uploadOss";
import ReturnNavBar from "@/components/mComponents/ReturnNavBar.vue";
import approveProcessSelect from "@/components/mComponents/approveProcessSelect";
import {EventBus} from '@/utils/eventBus';
export default {
    name: "WorkOrderFinish",
    components: { ReturnNavBar, approveProcessSelect },
    data() {
        return {
            loading: false,
            workorder_id: this.$route.query.id,
            workorder_num: this.$route.query.workorder_num,
            finishInfo: this.$route.query.finishInfo,
            workOrderFinishForm: {
                start_date: getNowDate(),
                start_time: 1,
                start_date_text: "",
                end_date: getNowDate(),
                end_time: 1,
                end_date_text: "",
                duration: 0,
                note: "",
                files: [],
                processing_uid: "",
                days: 0,
            },
            workOrderFinishFormRules: {
                start_date: [{ required: true, message: "请选择时间", trigger: ["blur", "change"] }],
                end_date: [{ required: true, message: "请选择时间", trigger: ["blur", "change"] }],
            },
            is_finish_upload: false,
            is_finish_content: false,

            processingUidData: [],

            previewImgList: [],
            previewImgSrc: "",

            approval_node_list: [],

            nowFieldFormData: "",
            currentField: "", // 当前选择的key

            showDateCalendar: false,
            dateCalendarMin: new Date("2015-01-01"),
            dateCalendarMax: new Date("2070-01-01"),

            handleRadioPicker: false,
            radioOptions: [
                { label: "上午", value: 1 },
                { label: "下午", value: 2 },
            ],
            btnDisabled: false,
        };
    },
    computed: {
        finishUploadRules() {
            if (this.is_finish_upload) {
                return [
                    {
                        required: true,
                        message: "请上传实施报告/证明",
                        trigger: ["blur", "change"],
                    },
                ];
            }
            return [];
        },
        finishContentRules() {
            if (this.is_finish_content) {
                return [
                    {
                        required: true,
                        message: "请填写结单描述",
                        trigger: ["blur", "change"],
                    },
                ];
            }
            return [];
        },
    },
    created() {
        this.getWorkOrderSetDetail();
        this.getApprovalNodesData();
        if (this.workorder_id) {
            this.getworkOrderFinishDetail();
        }
    },
    methods: {
        // 获取上传实施报告/证明，填写结单描述
        getWorkOrderSetDetail() {
            this.loading = true;
            workOrderSetDetail()
                .then((res) => {
                    this.is_finish_upload = res.data.is_finish_upload == 1 ? true : false;
                    this.is_finish_content = res.data.is_finish_content == 1 ? true : false;
                    this.loading = false;
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        // 获取数据
        getworkOrderFinishDetail() {
            workOrderFinishDetail({ workorder_id: this.workorder_id }).then((res) => {
                if (res.code === 200) {
                    const data = res.data;
                    this.processingUidData = data.processing || [];
                    this.workOrderFinishForm.start_date = data.start_date;
                    this.workOrderFinishForm.start_time = data.start_time;
                    this.workOrderFinishForm.end_date = data.end_date;
                    this.workOrderFinishForm.end_time = data.end_time;
                    this.workOrderFinishForm.duration = data.duration;
                    this.workOrderFinishForm.days = data.days;
                    this.workOrderFinishForm.processing_uid = data.processing.map((item) => item.id);
                }
            });
        },
        // 获取审批数据
        getApprovalNodesData() {
            this.loading = true;
            getApprovalNodes({
                approval_type: "workorder_finish",
            })
                .then((res) => {
                    if (res.code === 200) {
                        this.approval_node_list = res.data;
                        this.$refs.approveProcessSelectRef.set_approval_node_list(res.data);
                    } else {
                        this.$message.error(res.message);
                    }
                    this.loading = false;
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        // 时间选择
        handleClickDateFieldlink(currentField) {
            this.currentField = currentField;
            this.showDateCalendar = true;
        },
        //点击日期选择器确定事件
        handleDateCalenderConfirm(date) {
            this.currentDate = date;
            this.showDateCalendar = false;
            this.handleRadioPicker = true;
        },
        // 选择时间段确认
        handleClickOption(item) {
            this.$set(this.workOrderFinishForm, this.currentField, formatDate(this.currentDate, "date"));

            if (this.currentField === "start_date") {
                this.$set(this.workOrderFinishForm, "start_time", item.value);
                const date_txt = this.workOrderFinishForm.start_date + "-" + item.label;
                this.$set(this.workOrderFinishForm, "start_date_text", date_txt);
            } else {
                this.$set(this.workOrderFinishForm, "end_time", item.value);
                const date_txt = this.workOrderFinishForm.end_date + "-" + item.label;
                this.$set(this.workOrderFinishForm, "end_date_text", date_txt);
            }
            this.handleRadioPicker = false;
        },
        // 选择取消
        handleClickRadioCancel() {
            this.currentField = "";
            this.currentDate = null;
            this.handleRadioPicker = false;
        },
        //附件上传事件
        handleUploadFileChange(e, field, formData) {
            const files = e.target.files;
            const that = this;
            Array.from(files).forEach((file) => {
                if (file.size > 1024 * 1024 * 1024) return that.$message.error("附件大小不能超过1G");
                // if (field.file_type && field.file_type.length) {
                //     const fileType = file.name.match(/\.(\w+)$/)[1]; // 获取文件类型的后缀名
                //     if (!field.file_type.includes(fileType.toLowerCase()))
                //         return that.$message.error("上传文件类型不在管理员设置的范围内，请重新上传");
                // }
                uploadImg(file, file.size)
                    .then((res) => {
                        if (res.file_path) {
                            res.file_size = formatFileSize(file.size);
                            // formData[field].push(res);

                            let files_data =
                                typeof that.workOrderFinishForm.files == "string"
                                    ? []
                                    : JSON.parse(JSON.stringify(that.workOrderFinishForm.files || []));
                            files_data.push(res);
                            that.$set(that.workOrderFinishForm, "files", files_data);
                            e.target.value = "";
                        }
                        e.target.value = "";
                    })
                    .catch((error) => {
                        e.target.value = "";
                    });
            });
        },
        //附件预览事件
        handleClickPreview(file) {
            if (file.file_type.includes("image")) {
                this.previewImgList = [file.file_path];
                this.previewImgSrc = file.file_path;
                this.$refs.preview_img.showViewer = true;
            } else {
                if (file.file_type.includes("pdf")) {
                    window.open(file.file_path);
                } else {
                    this.$message.error("当前文件类型不支持预览");
                }
            }
        },
        handleClickConfirm() {
            this.$refs.workOrderFinishForm
                .validate()
                .then(() => {
                    if (this.is_finish_upload && !this.workOrderFinishForm.files.length)
                        return this.$toast("请上传实施报告/证明");
                    if (this.$refs.approveProcessSelectRef.handleClickPublish() == false) {
                        return false
                    };
                    let start_time = this.workOrderFinishForm.start_time == 1 ? '上午' : '下午'
                    let end_time =   this.workOrderFinishForm.end_time == 1   ? '上午' : '下午'
                    let finish_date = `${this.workOrderFinishForm.start_date} ${start_time} ${this.workOrderFinishForm.end_date} ${end_time}`;
                    const params = {
                        workorder_id: this.workorder_id,
                        workorder_num: this.workorder_num,
                        start_date: this.workOrderFinishForm.start_date,
                        start_time: this.workOrderFinishForm.start_time,
                        end_date: this.workOrderFinishForm.end_date,
                        end_time: this.workOrderFinishForm.end_time,
                        duration: this.workOrderFinishForm.duration,
                        days: this.workOrderFinishForm.days,
                        note: this.workOrderFinishForm.note,
                        files: this.workOrderFinishForm.files,
                        node_list: this.approval_node_list,
                        processing_users: this.processingUidData.map((item) => item.name),
                        finish_date:finish_date,
                        ...this.finishInfo,
                    };
                    workOrderFinish(params)
                        .then((res) => {
                            if (res.code === 200) {
                                this.$toast({
                                    message: res.message,
                                    type: "success",
                                    duration: 1000,
                                    onClose: () => {
                                        EventBus.$emit('workOrderAddUpdated');
                                        this.$router.go(-1);
                                        this.btnDisabled = false;
                                    },
                                });
                            } else {
                                this.btnDisabled = false;
                            }
                        })
                        .catch(() => {
                            this.btnDisabled = false;
                        });
                })
                .catch((err) => {
                    console.log(err)
                });
        },
    },
};
</script>
<style lang="scss" scoped>
.mobile_container {
    width: 100%;
    padding: 10px 0;
    box-sizing: border-box;
    .upload_file_list {
        border: 0;
        padding: 0;
        min-height: 40px;
        height: auto;
        overflow-y: visible;
        .upload_file_btn_wrap {
            text-align: center;
            &.mt_34 {
                margin-top: 34px;
            }
            .iconfont {
                margin-right: 8px;
            }
        }
    }
}
.add_approval_select_process {
    padding: 10px 16px;
    background: #fff;
}
.form_upload_wrap {
    width: 100%;
    text-align: left;
    .tip_info {
        font-size: 12px;
        font-weight: 400;
        letter-spacing: 0px;
        line-height: 18px;
        color: rgba(153, 153, 153, 1);
    }
}
</style>
